import { Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { HeroComponent } from '../../components/hero/hero';
import { AboutComponent } from '../../components/about/about';
import { OfferingsComponent } from '../../components/offerings/offerings';
import { GalleryComponent } from '../../components/gallery/gallery';
import { FaqComponent } from '../../components/faq/faq';
import { InfoComponent } from '../../components/info/info';
import { SloganComponent } from '../../components/slogan/slogan';
import { FooterComponent } from '../../components/footer/footer';
import { ROUTES } from '../../../../app.routes';

@Component({
  selector: 'app-landing',
  imports: [
    HeroComponent,
    AboutComponent,
    OfferingsComponent,
    GalleryComponent,
    FaqComponent,
    InfoComponent,
    SloganComponent,
    FooterComponent,
  ],
  templateUrl: './landing.html',
})
export class LandingComponent {

  private readonly router = inject(Router);

  protected openJoin(plan: number | null = null) {
    void this.router.navigate([ROUTES.join], {
      queryParams: plan != null ? { plan } : {},
    });
  }
}
